// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5820) return "static/chunks/5820-9c7bb3cb225195b5.js";
	if (chunkId === 3176) return "static/chunks/3176-2d5eb53d2c6a64d3.js";
	if (chunkId === 1890) return "static/chunks/1890-5c87a60e543b1593.js";
	if (chunkId === 6843) return "static/chunks/6843-471010b48c466e6e.js";
	if (chunkId === 4973) return "static/chunks/4973-4df40aee66e0e685.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3150":"be9c7a736bdf0657","5647":"b49bd3d36560bb22","6735":"a3eb23c166e5ee5a","6979":"f64f9efa7faaf7f2","7179":"de0415b9de056fe4","9292":"055a62ff94653476","9424":"09e83e0e06aac0bc"}[chunkId] + ".js";
};